import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@stimulus/polyfills';
import 'custom-event-polyfill/polyfill';
import 'classlist-polyfill';

if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function removePolyfill() {
    if (this.parentNode) this.parentNode.removeChild(this);
  };
}
